import "./App.css";
import { RouterProvider } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactGA from "react-ga4";
import useCountryCode from "./Hooks/useCountryCode";
import { CommonToast } from "./components/common/Toast";
import { getCountryNameByCountryCode } from "./utils/countriesState";
import { router } from "./router";

function App() {
  const { countryCode, loading } = useCountryCode();
  const [accessWeb, setAccessWeb] = useState(true);
  const stripePromise = loadStripe(
    process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY
  );

  useEffect(() => {
    const fetchCountryDetails = async () => {
      if (countryCode && !loading) {
        const countryDetails = await getCountryNameByCountryCode(countryCode);
        CommonToast.info(`Default country set to ${countryDetails.name}`)
      }
    };
    fetchCountryDetails();
  }, [countryCode])

   useEffect(() => {
    const env = process.env.REACT_APP_ENVIRONMENT;

    /* ---- Google Analytics ---- */
    if (env === "testing") {
      ReactGA.initialize("G-BXXHYLC766");
    } else if(env === "production") {
      ReactGA.initialize("G-DEZKKH8MFR");
    }

    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: window.location.href,
    });

    /* ---- Microsoft Clarity ---- */
    if (process.env.REACT_APP_MICROSOFT_CLARITY === "true") {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "uqe1v51g85");
    }
  }, []);

  useEffect(() => {
    if (localStorage?.getItem("Access_token")) {
      setAccessWeb(false);
    }
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <div className="App">
        <RouterProvider router={router} />
        <ToastContainer />
      </div>
    </Elements>

  );
}

export default App;
